import { Nullable } from '@ps/utils';

export interface SurveyLocationUploadResult {
  validCodes: string[];
  totalCodeCount: number;
  correctCodeCount: number;
  duplicateCodeCount: number;
  incorrectCodeCount: number;
  incorrectCodes: string[];
  modifiedCodeCount: number;
  filePath: string;
  groupedCodes: Record<string, string[]>;
}

export interface SurveyLocationUploadState {
  qualificationCode: Nullable<number>;
  loading: boolean;
  error: Nullable<string>;
  filePath: Nullable<string>;
  result: Nullable<SurveyLocationUploadResult>;
}

export const INITIAL_LOCATION_UPLOAD_STATE: SurveyLocationUploadState = {
  qualificationCode: null,
  loading: false,
  error: null,
  filePath: null,
  result: null,
};
